import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { Boundaries } from "@planzone/core";

const initialState: State = [];

function handleRequest(
  state: State,
  event: Boundaries["createVideoConferenceCall"]["request"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { event, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { event, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { event }: Boundaries["createVideoConferenceCall"]["success"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { event, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { event, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  event: Boundaries["createVideoConferenceCall"]["failure"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { event, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { event, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createVideoConferenceCallRequested]: handleRequest,
    [events.createVideoConferenceCallSucceeded]: handleSuccess,
    [events.createVideoConferenceCallFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
